import Common from "../common/Common";

class Footer1 {
  constructor() {
    this.common = new Common();
    this.mediaQueryList = this.common.matchMedia("md");

    this.initialize();
  }

  initialize() {
    if (document.querySelector(".l-footer")) {
      this.toggleNav1();
      this.pageTopButton();
    }
  }

  toggleNav1() {
    const buttons = document.querySelectorAll(".js-footerNav1Toggle");
    buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        if( button.classList.contains('is-active') ){
          button.classList.remove('is-active');
        } else {
          button.classList.add('is-active');
        }
      });
    });
  }

  pageTopButton() {
    const element = document.querySelector(".js-footerPagetop");
    let elementB = "";

    if (this.mediaQueryList.matches) {
      // SPサイズになった時の処理
      elementB = 4;
    } else {
      // PCサイズになった時の処理
      elementB = 20;
    }

    window.addEventListener("scroll", () => {
      const scrollPos = window.scrollY;

      // show
      if (scrollPos > 100) {
        element.classList.add("is-active");
      } else if (scrollPos < 10) {
        element.classList.remove("is-active");
      }

      // stop
      const scrollH = document.body.clientHeight;
      const elementH = element.offsetHeight;
      const windowH = window.innerHeight;
      const footer = document.querySelector(".l-footer__bottom");
      const footerH = footer.offsetHeight;
      //let stopArea = "";

      //if(document.querySelector(".p-footer-logo1")) {
      //  stopArea = document.querySelector(".p-footer-logo1");
      //} else {
      //  stopArea = document.querySelector(".l-footer__top");
      //}

      //const stopAreaH = stopArea.offsetHeight;
      let stopAreaH;
      if (this.mediaQueryList.matches) {
        // SPサイズになった時の処理
        stopAreaH = 72;
      } else {
        // PCサイズになった時の処理
        stopAreaH = 110;
      }

      const stopPos = (stopAreaH - elementH) / 2;

      if(scrollH - scrollPos - windowH + (stopPos - elementB) <= footerH) {
        element.classList.add('is-stop');
        element.style.bottom = footerH + stopPos + "px";
      } else {
        element.classList.remove('is-stop');
        element.style.bottom = null;
      }
    });
  }
}

export default Footer1;
